<template>
  <div class="">
    <group-permissions-edit
        v-model:show="showGroupPermissions"
        :zone="selectedZone"
        v-on:update:zoneGroups="updateZoneGroupsFromEditModal($event)"
    ></group-permissions-edit>

    <!-- Table -->
    <ajax-table :data="data"
                :headers="headers"
                v-model:loading="ajaxTable.loading"
                v-model:search="ajaxTable.search"
                v-model:sort-by="ajaxTable.sortBy"
                v-model:sort-desc="ajaxTable.sortDesc"
                v-model:page="ajaxTable.page"
                v-model:items-per-page="ajaxTable.itemsPerPage"
                v-model:page-info="ajaxTable.pageInfo"
                :exportable="false"
                @loadData="getData"
                @rowSelected="showGroupPermissionsModal"
    >
      <!-- Column 1: Area Name -->
      <template #col-1="props">
        <div    class="flex flex-col items-start justify-center">
                    <span   class="my-1 text-gray-700">
                        {{ props.row.area}}
                    </span>
        </div>
      </template>

      <!-- Column 2: Zone Name -->
      <template #col-2="props">
        <div    class="flex flex-col items-start justify-center">
                    <span   class="my-1 text-gray-700">
                        {{ props.row.zone}}
                    </span>
        </div>
      </template>

      <!-- Column 3: Groups -->
      <template #col-3="props">
        <div class="flex items-start flex-wrap">
          <div v-for="name in getActiveGroupNames(props.row.available_groups)">
                        <span class="inline-flex items-center m-1 px-2.5 py-0.5 rounded-md text-md font-medium bg-blue-100 text-blue-800">
                            {{ name }}
                        </span>
          </div>
        </div>

      </template>
    </ajax-table>
  </div>
</template>

<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Pagination from "@/components/Pagination"
import ItemsPerPageSelect from "@/components/ItemsPerPageSelect"
import FloatingInput from "@/components/elements/FloatingInput";
import Select2 from '@/components/elements/select2'
import GreenButton from "@/components/elements/green-button";
import AjaxTable from "@/components/elements/AjaxTable";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import Loading from "@/components/elements/loading";
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";
import {UrlParamsMixin} from "@/mixins/UrlParamsMixin";
import _isNil from "lodash";
import GroupsEdit from "@/components/Groups/GroupsEdit";

export default {
  name: "GroupPermissionsIndex",
  mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin, UrlParamsMixin],
  components: {
    SmallColoredCheck,
    GroupsEdit,
    Loading, AjaxTable, GreenButton, Pagination, ItemsPerPageSelect, FloatingInput, Select2
  },
  props: {
  },
  data() {
    return {
      data: [],
      headers: [
        {
          name: 'Area Name',
          sortBy: 'area_name',
          show: 'sm',
          key: 'area_name',
        },
        {
          name: 'Zone Name',
          sortBy: 'zone_name',
          show: 'sm',
          key: 'zone_name',
        },
        {
          name: 'Groups',
          sortBy: '',
          show: 'md',
          key: 'groups',
        },
      ],
      requestNumber: 0,
      // For Modal
      showGroupPermissions: false,
      selectedZone: null,
      selectedZoneIndex: null,
      preLoadGroupPermission: null,
    }
  },
  created() {
    this.ajaxTable.sortBy = 'area_name'
  },
  mounted() {
    this.preLoadGroup = this.urlParamsGet('groupPermission')
  },
  methods: {
    getData() {
      this.ajaxTable.loading = true
      this.requestNumber++
      let params = JSON.parse(JSON.stringify(this.ajaxTable))
      params.requestNumber = this.requestNumber
      axios.get(this.company.buildCompanyApiInternalRoute('group-permissions'),
          {
            params: params,
          }
      ).then(response => {
        console.log(response);
        let data = response.data.data;
        data.meta = {};
        data.meta.current_page = data.current_page;
        data.meta.from = data.from;
        data.meta.to = data.to;
        data.meta.path = data.path;
        data.meta.per_page = data.per_page;
        data.meta.last_page = data.last_page;
        data.meta.requestNumber = response.data.requestNumber;
        if (data.meta.requestNumber !== `${this.requestNumber}`) {
          return
        }
        this.ajaxUpdateTableData(data); // This sends the data to the mixin for AjaxTable

        this.data = !_.isNil(data.data) ? data.data : [];

        if(this.preLoadGroup){
          let selectedGroupId = this.preLoadGroup;
          let selectedGroupIndex = _.findIndex(this.data, function(groupObj) {
            return groupObj.id === parseInt(selectedGroupId);
          });
          if(!_.isNil(selectedGroupIndex) && selectedGroupIndex >= 0){
            this.showGroupModal(selectedGroupIndex);
          } else {
            console.log('removing unfound group');
            this.urlParamsRemove('group');
          }
        }
      }).catch(error => {
        console.log(error)
      }).then(() => {
        this.ajaxTable.loading = false
      })
    },
    showGroupPermissionsModal(rowIndex) {
      this.selectedZone = this.data[rowIndex];
      this.showGroupPermissions = true;
      this.selectedGroupPermisisonsIndex = rowIndex;
      this.urlParamsStore('group_permissions', this.data[rowIndex].id)
    },
    updateZoneGroupsFromEditModal(foo){
      console.log('update');
      console.log(foo);
      this.data[this.selectedZoneIndex] = foo
    },
    getActiveGroupNames(availableGroups){
      var groupNames = [];
      for (const[key, value] of Object.entries(availableGroups)){
        if(value[2]){
          groupNames.push(value[1]);
        }
      }
      return groupNames
    }
  },
  computed: {},
  watch: {
    showGroupPermissions(val) {
      if (!val) {
        this.urlParamsRemove('group_permissions')
      }
    }
  },
}
</script>

<style scoped>

</style>